import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=99ff8004&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff8004",
  null
  
)

export default component.exports